module.exports = __webpack_public_path__ + "img/news2.c0a728fb.jpeg";